export function Dash() {
  return <span className="text-dim-foreground text-sm">-</span>
}
